import { axios } from '@/utils/request'

export function getAppVendor (id) {
  return axios({
    url: '/vendor/' + id,
    method: 'get'
  })
}

export function listAllVendors () {
  return axios({
    url: '/vendors',
    method: 'get'
  })
}

export function createAppVendor (form) {
  return axios({
    url: '/vendor',
    method: 'post',
    data: form
  })
}

export function updateAppVendor (id, form) {
  return axios({
    url: '/vendor/' + id,
    method: 'put',
    data: form
  })
}

export function removeAppVendor (id) {
  return axios({
    url: '/vendor/' + id,
    method: 'delete'
  })
}

export function addHotel (id, hotel) {
  return axios({
    url: '/vendor/' + id + '/hotel',
    method: 'post',
    data: hotel
  })
}

export function updateHotel (hotel) {
  return axios({
    url: '/vendor/hotel',
    method: 'put',
    data: hotel
  })
}

export function removeHotel (uuid) {
  return axios({
    url: '/vendor/hotel/' + uuid,
    method: 'delete'
  })
}

export function addApk (id, apk) {
  return axios({
    url: '/vendor/' + id + '/apk',
    method: 'post',
    data: apk
  })
}

export function removeApk (id, apk) {
  return axios({
    url: '/vendor/' + id + '/apk',
    method: 'delete',
    data: apk
  })
}

export function grantHotelCode (uuid) {
  return axios({
    url: '/vendor/hotel/' + uuid + '/code',
    method: 'post'
  })
}

export function recycleHotelCode (uuid) {
  return axios({
    url: '/vendor/hotel/' + uuid + '/code',
    method: 'delete'
  })
}

export function costTrend () {
  return axios({
    url: '/vendor/cost-trend',
    method: 'get'
  })
}
